/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CapacitiesRow,
    CapacitiesRowFromJSON,
    CapacitiesRowFromJSONTyped,
    CapacitiesRowToJSON,
} from './';

/**
 * 上限リスト
 * @export
 * @interface CapacitiesList
 */
export interface CapacitiesList {
    /**
     * 
     * @type {Array<CapacitiesRow>}
     * @memberof CapacitiesList
     */
    capacities?: Array<CapacitiesRow>;
}

export function CapacitiesListFromJSON(json: any): CapacitiesList {
    return CapacitiesListFromJSONTyped(json, false);
}

export function CapacitiesListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapacitiesList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'capacities': !exists(json, 'capacities') ? undefined : ((json['capacities'] as Array<any>).map(CapacitiesRowFromJSON)),
    };
}

export function CapacitiesListToJSON(value?: CapacitiesList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'capacities': value.capacities === undefined ? undefined : ((value.capacities as Array<any>).map(CapacitiesRowToJSON)),
    };
}


